<template>
  <ExportModal ref="exportModal" title="Faturas Pagas" @submit:export="submitExport" :loading="exportLoading" />
</template>

<script>
import ExportModal from '../../../export/ExportModal'
import _export from '../../../../services/export'

export default {
  name: 'FaturasPagasModal',
  components: {
    ExportModal,
  },
  data() {
    return {
      exportLoading: false,
    }
  },
  methods: {
    open() {
      this.$refs.exportModal.open()
    },
    async submitExport(e) {
      this.exportLoading = true

      const params = {
        periodo: [e.initialDate, e.finalDate],
        tipo: e.format,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/faturamento/exportar/recebimentos`, {
        params,
      })
        .then((res) => {
          switch (e.format) {
            case 'pdf': {
              _export.downloadPDF(res.body.arquivo, 'recebido_periodo')
              break
            }
            case 'csv': {
              _export.downloadCSV(res.body.arquivo, 'recebido_periodo')
              break
            }
          }
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório: ${err.body.mensagem}`, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
  }
}
</script>

<style lang="scss" scoped></style>
